class m {
  equals(e, t = ["span"]) {
    const n = new Set(Object.keys(this)), s = new Set(Object.keys(e));
    if (t)
      for (const i of t)
        n.delete(i), s.delete(i);
    if (n.size !== s.size)
      return !1;
    for (const i of n) {
      if (!s.has(i))
        return !1;
      const a = this[i], c = e[i];
      if (typeof a != typeof c)
        return !1;
      if (a instanceof Array && c instanceof Array) {
        if (a.length !== c.length)
          return !1;
        for (let f = 0; f < a.length; ++f)
          if (!P(a[f], c[f], t))
            return !1;
      } else if (!P(a, c, t))
        return !1;
    }
    return !0;
  }
  clone() {
    function e(n) {
      return n instanceof m ? n.clone() : Array.isArray(n) ? n.map(e) : n;
    }
    const t = Object.create(this.constructor.prototype);
    for (const n of Object.keys(this))
      t[n] = e(this[n]);
    return t;
  }
}
function P(r, e, t) {
  return r instanceof m && e instanceof m ? r.equals(e, t) : r === e;
}
class o extends m {
  /** @ignore */
  addSpan(e, t) {
    this.span = new N(e, t);
  }
}
class R extends o {
  constructor(e = []) {
    super(), this.type = "Resource", this.body = e;
  }
}
class v extends o {
  constructor(e, t = null, n = [], s = null) {
    super(), this.type = "Message", this.id = e, this.value = t, this.attributes = n, this.comment = s;
  }
}
class I extends o {
  constructor(e, t, n = [], s = null) {
    super(), this.type = "Term", this.id = e, this.value = t, this.attributes = n, this.comment = s;
  }
}
class V extends o {
  constructor(e) {
    super(), this.type = "Pattern", this.elements = e;
  }
}
class k extends o {
  constructor(e) {
    super(), this.type = "TextElement", this.value = e;
  }
}
class x extends o {
  constructor(e) {
    super(), this.type = "Placeable", this.expression = e;
  }
}
class O extends o {
  constructor(e) {
    super(), this.value = e;
  }
}
class j extends O {
  constructor() {
    super(...arguments), this.type = "StringLiteral";
  }
  parse() {
    const e = /(?:\\\\|\\"|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
    function t(s, i, a) {
      switch (s) {
        case "\\\\":
          return "\\";
        case '\\"':
          return '"';
        default: {
          let c = parseInt(i || a, 16);
          return c <= 55295 || 57344 <= c ? String.fromCodePoint(c) : "�";
        }
      }
    }
    return { value: this.value.replace(e, t) };
  }
}
class q extends O {
  constructor() {
    super(...arguments), this.type = "NumberLiteral";
  }
  parse() {
    let e = parseFloat(this.value), t = this.value.indexOf("."), n = t > 0 ? this.value.length - t - 1 : 0;
    return { value: e, precision: n };
  }
}
class w extends o {
  constructor(e, t = null) {
    super(), this.type = "MessageReference", this.id = e, this.attribute = t;
  }
}
class E extends o {
  constructor(e, t = null, n = null) {
    super(), this.type = "TermReference", this.id = e, this.attribute = t, this.arguments = n;
  }
}
class D extends o {
  constructor(e) {
    super(), this.type = "VariableReference", this.id = e;
  }
}
class J extends o {
  constructor(e, t) {
    super(), this.type = "FunctionReference", this.id = e, this.arguments = t;
  }
}
class M extends o {
  constructor(e, t) {
    super(), this.type = "SelectExpression", this.selector = e, this.variants = t;
  }
}
class F extends o {
  constructor(e = [], t = []) {
    super(), this.type = "CallArguments", this.positional = e, this.named = t;
  }
}
class G extends o {
  constructor(e, t) {
    super(), this.type = "Attribute", this.id = e, this.value = t;
  }
}
class U extends o {
  constructor(e, t, n) {
    super(), this.type = "Variant", this.key = e, this.value = t, this.default = n;
  }
}
class A extends o {
  constructor(e, t) {
    super(), this.type = "NamedArgument", this.name = e, this.value = t;
  }
}
class z extends o {
  constructor(e) {
    super(), this.type = "Identifier", this.name = e;
  }
}
class b extends o {
  constructor(e) {
    super(), this.content = e;
  }
}
class B extends b {
  constructor() {
    super(...arguments), this.type = "Comment";
  }
}
class _ extends b {
  constructor() {
    super(...arguments), this.type = "GroupComment";
  }
}
class H extends b {
  constructor() {
    super(...arguments), this.type = "ResourceComment";
  }
}
class $ extends o {
  constructor(e) {
    super(), this.type = "Junk", this.annotations = [], this.content = e;
  }
  addAnnotation(e) {
    this.annotations.push(e);
  }
}
class N extends m {
  constructor(e, t) {
    super(), this.type = "Span", this.start = e, this.end = t;
  }
}
class K extends o {
  constructor(e, t = [], n) {
    super(), this.type = "Annotation", this.code = e, this.arguments = t, this.message = n;
  }
}
class u extends Error {
  constructor(e, ...t) {
    super(), this.code = e, this.args = t, this.message = Z(e, t);
  }
}
function Z(r, e) {
  switch (r) {
    case "E0001":
      return "Generic error";
    case "E0002":
      return "Expected an entry start";
    case "E0003": {
      const [t] = e;
      return `Expected token: "${t}"`;
    }
    case "E0004": {
      const [t] = e;
      return `Expected a character from range: "${t}"`;
    }
    case "E0005": {
      const [t] = e;
      return `Expected message "${t}" to have a value or attributes`;
    }
    case "E0006": {
      const [t] = e;
      return `Expected term "-${t}" to have a value`;
    }
    case "E0007":
      return "Keyword cannot end with a whitespace";
    case "E0008":
      return "The callee has to be an upper-case identifier or a term";
    case "E0009":
      return "The argument name has to be a simple identifier";
    case "E0010":
      return "Expected one of the variants to be marked as default (*)";
    case "E0011":
      return 'Expected at least one variant after "->"';
    case "E0012":
      return "Expected value";
    case "E0013":
      return "Expected variant key";
    case "E0014":
      return "Expected literal";
    case "E0015":
      return "Only one variant can be marked as default (*)";
    case "E0016":
      return "Message references cannot be used as selectors";
    case "E0017":
      return "Terms cannot be used as selectors";
    case "E0018":
      return "Attributes of messages cannot be used as selectors";
    case "E0019":
      return "Attributes of terms cannot be used as placeables";
    case "E0020":
      return "Unterminated string expression";
    case "E0021":
      return "Positional arguments must not follow named arguments";
    case "E0022":
      return "Named arguments must be unique";
    case "E0024":
      return "Cannot access variants of a message.";
    case "E0025": {
      const [t] = e;
      return `Unknown escape sequence: \\${t}.`;
    }
    case "E0026": {
      const [t] = e;
      return `Invalid Unicode escape sequence: ${t}.`;
    }
    case "E0027":
      return "Unbalanced closing brace in TextElement.";
    case "E0028":
      return "Expected an inline expression";
    case "E0029":
      return "Expected simple expression as selector";
    default:
      return r;
  }
}
class W {
  constructor(e) {
    this.string = e, this.index = 0, this.peekOffset = 0;
  }
  charAt(e) {
    return this.string[e] === "\r" && this.string[e + 1] === `
` ? `
` : this.string[e];
  }
  currentChar() {
    return this.charAt(this.index);
  }
  currentPeek() {
    return this.charAt(this.index + this.peekOffset);
  }
  next() {
    return this.peekOffset = 0, this.string[this.index] === "\r" && this.string[this.index + 1] === `
` && this.index++, this.index++, this.string[this.index];
  }
  peek() {
    return this.string[this.index + this.peekOffset] === "\r" && this.string[this.index + this.peekOffset + 1] === `
` && this.peekOffset++, this.peekOffset++, this.string[this.index + this.peekOffset];
  }
  resetPeek(e = 0) {
    this.peekOffset = e;
  }
  skipToPeek() {
    this.index += this.peekOffset, this.peekOffset = 0;
  }
}
const d = `
`, g = void 0, Q = ["}", ".", "[", "*"];
class T extends W {
  peekBlankInline() {
    const e = this.index + this.peekOffset;
    for (; this.currentPeek() === " "; )
      this.peek();
    return this.string.slice(e, this.index + this.peekOffset);
  }
  skipBlankInline() {
    const e = this.peekBlankInline();
    return this.skipToPeek(), e;
  }
  peekBlankBlock() {
    let e = "";
    for (; ; ) {
      const t = this.peekOffset;
      if (this.peekBlankInline(), this.currentPeek() === d) {
        e += d, this.peek();
        continue;
      }
      return this.currentPeek() === g || this.resetPeek(t), e;
    }
  }
  skipBlankBlock() {
    const e = this.peekBlankBlock();
    return this.skipToPeek(), e;
  }
  peekBlank() {
    for (; this.currentPeek() === " " || this.currentPeek() === d; )
      this.peek();
  }
  skipBlank() {
    this.peekBlank(), this.skipToPeek();
  }
  expectChar(e) {
    if (this.currentChar() === e) {
      this.next();
      return;
    }
    throw new u("E0003", e);
  }
  expectLineEnd() {
    if (this.currentChar() !== g) {
      if (this.currentChar() === d) {
        this.next();
        return;
      }
      throw new u("E0003", "␤");
    }
  }
  takeChar(e) {
    const t = this.currentChar();
    return t === g ? g : e(t) ? (this.next(), t) : null;
  }
  isCharIdStart(e) {
    if (e === g)
      return !1;
    const t = e.charCodeAt(0);
    return t >= 97 && t <= 122 || // a-z
    t >= 65 && t <= 90;
  }
  isIdentifierStart() {
    return this.isCharIdStart(this.currentPeek());
  }
  isNumberStart() {
    const e = this.currentChar() === "-" ? this.peek() : this.currentChar();
    if (e === g)
      return this.resetPeek(), !1;
    const t = e.charCodeAt(0), n = t >= 48 && t <= 57;
    return this.resetPeek(), n;
  }
  isCharPatternContinuation(e) {
    return e === g ? !1 : !Q.includes(e);
  }
  isValueStart() {
    const e = this.currentPeek();
    return e !== d && e !== g;
  }
  isValueContinuation() {
    const e = this.peekOffset;
    return this.peekBlankInline(), this.currentPeek() === "{" ? (this.resetPeek(e), !0) : this.peekOffset - e === 0 ? !1 : this.isCharPatternContinuation(this.currentPeek()) ? (this.resetPeek(e), !0) : !1;
  }
  /**
   * @param level - -1: any, 0: comment, 1: group comment, 2: resource comment
   */
  isNextLineComment(e = -1) {
    if (this.currentChar() !== d)
      return !1;
    let t = 0;
    for (; t <= e || e === -1 && t < 3; ) {
      if (this.peek() !== "#") {
        if (t <= e && e !== -1)
          return this.resetPeek(), !1;
        break;
      }
      t++;
    }
    const n = this.peek();
    return n === " " || n === d ? (this.resetPeek(), !0) : (this.resetPeek(), !1);
  }
  isVariantStart() {
    const e = this.peekOffset;
    return this.currentPeek() === "*" && this.peek(), this.currentPeek() === "[" ? (this.resetPeek(e), !0) : (this.resetPeek(e), !1);
  }
  isAttributeStart() {
    return this.currentPeek() === ".";
  }
  skipToNextEntryStart(e) {
    let t = this.string.lastIndexOf(d, this.index);
    for (e < t && (this.index = t); this.currentChar(); ) {
      if (this.currentChar() !== d) {
        this.next();
        continue;
      }
      const n = this.next();
      if (this.isCharIdStart(n) || n === "-" || n === "#")
        break;
    }
  }
  takeIDStart() {
    if (this.isCharIdStart(this.currentChar())) {
      const e = this.currentChar();
      return this.next(), e;
    }
    throw new u("E0004", "a-zA-Z");
  }
  takeIDChar() {
    const e = (t) => {
      const n = t.charCodeAt(0);
      return n >= 97 && n <= 122 || // a-z
      n >= 65 && n <= 90 || // A-Z
      n >= 48 && n <= 57 || // 0-9
      n === 95 || n === 45;
    };
    return this.takeChar(e);
  }
  takeDigit() {
    const e = (t) => {
      const n = t.charCodeAt(0);
      return n >= 48 && n <= 57;
    };
    return this.takeChar(e);
  }
  takeHexDigit() {
    const e = (t) => {
      const n = t.charCodeAt(0);
      return n >= 48 && n <= 57 || // 0-9
      n >= 65 && n <= 70 || // A-F
      n >= 97 && n <= 102;
    };
    return this.takeChar(e);
  }
}
const X = /[ \n\r]+$/;
function h(r) {
  return function(e, ...t) {
    if (!this.withSpans)
      return r.call(this, e, ...t);
    const n = e.index, s = r.call(this, e, ...t);
    if (s.span)
      return s;
    const i = e.index;
    return s.addSpan(n, i), s;
  };
}
class Y {
  constructor({ withSpans: e = !0 } = {}) {
    this.withSpans = e, this.getComment = h(this.getComment), this.getMessage = h(this.getMessage), this.getTerm = h(this.getTerm), this.getAttribute = h(this.getAttribute), this.getIdentifier = h(this.getIdentifier), this.getVariant = h(this.getVariant), this.getNumber = h(this.getNumber), this.getPattern = h(this.getPattern), this.getTextElement = h(this.getTextElement), this.getPlaceable = h(this.getPlaceable), this.getExpression = h(this.getExpression), this.getInlineExpression = h(this.getInlineExpression), this.getCallArgument = h(this.getCallArgument), this.getCallArguments = h(this.getCallArguments), this.getString = h(this.getString), this.getLiteral = h(this.getLiteral), this.getComment = h(this.getComment);
  }
  parse(e) {
    const t = new T(e);
    t.skipBlankBlock();
    const n = [];
    let s = null;
    for (; t.currentChar(); ) {
      const a = this.getEntryOrJunk(t), c = t.skipBlankBlock();
      if (a instanceof B && c.length === 0 && t.currentChar()) {
        s = a;
        continue;
      }
      s && (a instanceof v || a instanceof I ? (a.comment = s, this.withSpans && (a.span.start = a.comment.span.start)) : n.push(s), s = null), n.push(a);
    }
    const i = new R(n);
    return this.withSpans && i.addSpan(0, t.index), i;
  }
  /**
   * Parse the first Message or Term in `source`.
   *
   * Skip all encountered comments and start parsing at the first Message or
   * Term start. Return Junk if the parsing is not successful.
   *
   * Preceding comments are ignored unless they contain syntax errors
   * themselves, in which case Junk for the invalid comment is returned.
   */
  parseEntry(e) {
    const t = new T(e);
    for (t.skipBlankBlock(); t.currentChar() === "#"; ) {
      const n = this.getEntryOrJunk(t);
      if (n instanceof $)
        return n;
      t.skipBlankBlock();
    }
    return this.getEntryOrJunk(t);
  }
  getEntryOrJunk(e) {
    const t = e.index;
    try {
      const n = this.getEntry(e);
      return e.expectLineEnd(), n;
    } catch (n) {
      if (!(n instanceof u))
        throw n;
      let s = e.index;
      e.skipToNextEntryStart(t);
      const i = e.index;
      i < s && (s = i);
      const a = e.string.substring(t, i), c = new $(a);
      this.withSpans && c.addSpan(t, i);
      const f = new K(n.code, n.args, n.message);
      return f.addSpan(s, s), c.addAnnotation(f), c;
    }
  }
  getEntry(e) {
    if (e.currentChar() === "#")
      return this.getComment(e);
    if (e.currentChar() === "-")
      return this.getTerm(e);
    if (e.isIdentifierStart())
      return this.getMessage(e);
    throw new u("E0002");
  }
  getComment(e) {
    let t = -1, n = "";
    for (; ; ) {
      let i = -1;
      for (; e.currentChar() === "#" && i < (t === -1 ? 2 : t); )
        e.next(), i++;
      if (t === -1 && (t = i), e.currentChar() !== d) {
        e.expectChar(" ");
        let a;
        for (; a = e.takeChar((c) => c !== d); )
          n += a;
      }
      if (e.isNextLineComment(t))
        n += e.currentChar(), e.next();
      else
        break;
    }
    let s;
    switch (t) {
      case 0:
        s = B;
        break;
      case 1:
        s = _;
        break;
      default:
        s = H;
    }
    return new s(n);
  }
  getMessage(e) {
    const t = this.getIdentifier(e);
    e.skipBlankInline(), e.expectChar("=");
    const n = this.maybeGetPattern(e), s = this.getAttributes(e);
    if (n === null && s.length === 0)
      throw new u("E0005", t.name);
    return new v(t, n, s);
  }
  getTerm(e) {
    e.expectChar("-");
    const t = this.getIdentifier(e);
    e.skipBlankInline(), e.expectChar("=");
    const n = this.maybeGetPattern(e);
    if (n === null)
      throw new u("E0006", t.name);
    const s = this.getAttributes(e);
    return new I(t, n, s);
  }
  getAttribute(e) {
    e.expectChar(".");
    const t = this.getIdentifier(e);
    e.skipBlankInline(), e.expectChar("=");
    const n = this.maybeGetPattern(e);
    if (n === null)
      throw new u("E0012");
    return new G(t, n);
  }
  getAttributes(e) {
    const t = [];
    for (e.peekBlank(); e.isAttributeStart(); ) {
      e.skipToPeek();
      const n = this.getAttribute(e);
      t.push(n), e.peekBlank();
    }
    return t;
  }
  getIdentifier(e) {
    let t = e.takeIDStart(), n;
    for (; n = e.takeIDChar(); )
      t += n;
    return new z(t);
  }
  getVariantKey(e) {
    const t = e.currentChar();
    if (t === g)
      throw new u("E0013");
    const n = t.charCodeAt(0);
    return n >= 48 && n <= 57 || n === 45 ? this.getNumber(e) : this.getIdentifier(e);
  }
  getVariant(e, t = !1) {
    let n = !1;
    if (e.currentChar() === "*") {
      if (t)
        throw new u("E0015");
      e.next(), n = !0;
    }
    e.expectChar("["), e.skipBlank();
    const s = this.getVariantKey(e);
    e.skipBlank(), e.expectChar("]");
    const i = this.maybeGetPattern(e);
    if (i === null)
      throw new u("E0012");
    return new U(s, i, n);
  }
  getVariants(e) {
    const t = [];
    let n = !1;
    for (e.skipBlank(); e.isVariantStart(); ) {
      const s = this.getVariant(e, n);
      s.default && (n = !0), t.push(s), e.expectLineEnd(), e.skipBlank();
    }
    if (t.length === 0)
      throw new u("E0011");
    if (!n)
      throw new u("E0010");
    return t;
  }
  getDigits(e) {
    let t = "", n;
    for (; n = e.takeDigit(); )
      t += n;
    if (t.length === 0)
      throw new u("E0004", "0-9");
    return t;
  }
  getNumber(e) {
    let t = "";
    return e.currentChar() === "-" ? (e.next(), t += `-${this.getDigits(e)}`) : t += this.getDigits(e), e.currentChar() === "." && (e.next(), t += `.${this.getDigits(e)}`), new q(t);
  }
  /**
   * maybeGetPattern distinguishes between patterns which start on the same line
   * as the identifier (a.k.a. inline signleline patterns and inline multiline
   * patterns) and patterns which start on a new line (a.k.a. block multiline
   * patterns). The distinction is important for the dedentation logic: the
   * indent of the first line of a block pattern must be taken into account when
   * calculating the maximum common indent.
   */
  maybeGetPattern(e) {
    return e.peekBlankInline(), e.isValueStart() ? (e.skipToPeek(), this.getPattern(e, !1)) : (e.peekBlankBlock(), e.isValueContinuation() ? (e.skipToPeek(), this.getPattern(e, !0)) : null);
  }
  getPattern(e, t) {
    const n = [];
    let s;
    if (t) {
      const c = e.index, f = e.skipBlankInline();
      n.push(this.getIndent(e, f, c)), s = f.length;
    } else
      s = 1 / 0;
    let i;
    e: for (; i = e.currentChar(); )
      switch (i) {
        case d: {
          const c = e.index, f = e.peekBlankBlock();
          if (e.isValueContinuation()) {
            e.skipToPeek();
            const S = e.skipBlankInline();
            s = Math.min(s, S.length), n.push(this.getIndent(e, f + S, c));
            continue e;
          }
          e.resetPeek();
          break e;
        }
        case "{":
          n.push(this.getPlaceable(e));
          continue e;
        case "}":
          throw new u("E0027");
        default:
          n.push(this.getTextElement(e));
      }
    const a = this.dedent(n, s);
    return new V(a);
  }
  /**
   * Create a token representing an indent. It's not part of the AST and it will
   * be trimmed and merged into adjacent TextElements, or turned into a new
   * TextElement, if it's surrounded by two Placeables.
   */
  getIndent(e, t, n) {
    return new C(t, n, e.index);
  }
  /**
   * Dedent a list of elements by removing the maximum common indent from the
   * beginning of text lines. The common indent is calculated in getPattern.
   */
  dedent(e, t) {
    const n = [];
    for (let i of e) {
      if (i instanceof x) {
        n.push(i);
        continue;
      }
      if (i instanceof C && (i.value = i.value.slice(0, i.value.length - t), i.value.length === 0))
        continue;
      let a = n[n.length - 1];
      if (a && a instanceof k) {
        const c = new k(a.value + i.value);
        this.withSpans && c.addSpan(a.span.start, i.span.end), n[n.length - 1] = c;
        continue;
      }
      if (i instanceof C) {
        const c = new k(i.value);
        this.withSpans && c.addSpan(i.span.start, i.span.end), i = c;
      }
      n.push(i);
    }
    const s = n[n.length - 1];
    return s instanceof k && (s.value = s.value.replace(X, ""), s.value.length === 0 && n.pop()), n;
  }
  getTextElement(e) {
    let t = "", n;
    for (; n = e.currentChar(); ) {
      if (n === "{" || n === "}")
        return new k(t);
      if (n === d)
        return new k(t);
      t += n, e.next();
    }
    return new k(t);
  }
  getEscapeSequence(e) {
    const t = e.currentChar();
    switch (t) {
      case "\\":
      case '"':
        return e.next(), `\\${t}`;
      case "u":
        return this.getUnicodeEscapeSequence(e, t, 4);
      case "U":
        return this.getUnicodeEscapeSequence(e, t, 6);
      default:
        throw new u("E0025", t);
    }
  }
  getUnicodeEscapeSequence(e, t, n) {
    e.expectChar(t);
    let s = "";
    for (let i = 0; i < n; i++) {
      const a = e.takeHexDigit();
      if (!a)
        throw new u("E0026", `\\${t}${s}${e.currentChar()}`);
      s += a;
    }
    return `\\${t}${s}`;
  }
  getPlaceable(e) {
    e.expectChar("{"), e.skipBlank();
    const t = this.getExpression(e);
    return e.expectChar("}"), new x(t);
  }
  getExpression(e) {
    const t = this.getInlineExpression(e);
    if (e.skipBlank(), e.currentChar() === "-") {
      if (e.peek() !== ">")
        return e.resetPeek(), t;
      if (t instanceof w)
        throw t.attribute === null ? new u("E0016") : new u("E0018");
      if (t instanceof E) {
        if (t.attribute === null)
          throw new u("E0017");
      } else if (t instanceof x)
        throw new u("E0029");
      e.next(), e.next(), e.skipBlankInline(), e.expectLineEnd();
      const n = this.getVariants(e);
      return new M(t, n);
    }
    if (t instanceof E && t.attribute !== null)
      throw new u("E0019");
    return t;
  }
  getInlineExpression(e) {
    if (e.currentChar() === "{")
      return this.getPlaceable(e);
    if (e.isNumberStart())
      return this.getNumber(e);
    if (e.currentChar() === '"')
      return this.getString(e);
    if (e.currentChar() === "$") {
      e.next();
      const t = this.getIdentifier(e);
      return new D(t);
    }
    if (e.currentChar() === "-") {
      e.next();
      const t = this.getIdentifier(e);
      let n;
      e.currentChar() === "." && (e.next(), n = this.getIdentifier(e));
      let s;
      return e.peekBlank(), e.currentPeek() === "(" && (e.skipToPeek(), s = this.getCallArguments(e)), new E(t, n, s);
    }
    if (e.isIdentifierStart()) {
      const t = this.getIdentifier(e);
      if (e.peekBlank(), e.currentPeek() === "(") {
        if (!/^[A-Z][A-Z0-9_-]*$/.test(t.name))
          throw new u("E0008");
        e.skipToPeek();
        let s = this.getCallArguments(e);
        return new J(t, s);
      }
      let n;
      return e.currentChar() === "." && (e.next(), n = this.getIdentifier(e)), new w(t, n);
    }
    throw new u("E0028");
  }
  getCallArgument(e) {
    const t = this.getInlineExpression(e);
    if (e.skipBlank(), e.currentChar() !== ":")
      return t;
    if (t instanceof w && t.attribute === null) {
      e.next(), e.skipBlank();
      const n = this.getLiteral(e);
      return new A(t.id, n);
    }
    throw new u("E0009");
  }
  getCallArguments(e) {
    const t = [], n = [], s = /* @__PURE__ */ new Set();
    for (e.expectChar("("), e.skipBlank(); e.currentChar() !== ")"; ) {
      const i = this.getCallArgument(e);
      if (i instanceof A) {
        if (s.has(i.name.name))
          throw new u("E0022");
        n.push(i), s.add(i.name.name);
      } else {
        if (s.size > 0)
          throw new u("E0021");
        t.push(i);
      }
      if (e.skipBlank(), e.currentChar() === ",") {
        e.next(), e.skipBlank();
        continue;
      }
      break;
    }
    return e.expectChar(")"), new F(t, n);
  }
  getString(e) {
    e.expectChar('"');
    let t = "", n;
    for (; n = e.takeChar((s) => s !== '"' && s !== d); )
      n === "\\" ? t += this.getEscapeSequence(e) : t += n;
    if (e.currentChar() === d)
      throw new u("E0020");
    return e.expectChar('"'), new j(t);
  }
  getLiteral(e) {
    if (e.isNumberStart())
      return this.getNumber(e);
    if (e.currentChar() === '"')
      return this.getString(e);
    throw new u("E0014");
  }
}
class C {
  /** @ignore */
  constructor(e, t, n) {
    this.type = "Indent", this.value = e, this.span = new N(t, n);
  }
}
function ee(r, e) {
  return new Y(e).parse(r);
}
const l = (r, e) => {
  switch (r.type) {
    case "FunctionReference":
      return `${r.id.name}(${l(r.arguments)})`;
    case "TermReference":
      return `-${r.id.name}`;
    case "Identifier":
      return r.name;
    case "StringLiteral":
    case "NumberLiteral":
    case "TextElement":
      return r.value;
    case "Pattern":
      return r.elements.map((t) => l(t)).join("");
    case "CallArguments": {
      const t = r.positional.map((s) => l(s, !0)).join(" "), n = r.named.map((s) => l(s)).join(", ");
      return `$${t}${n.length ? `, ${n}` : ""}`;
    }
    case "NamedArgument":
      return `${l(r.name)}: "${l(r.value)}"`;
    case "SelectExpression": {
      const t = l(r.selector, !0), n = r.variants.map((s) => l(s));
      return [`$${t} ->`, ...n].join(`
 `) + `
`;
    }
    case "VariableReference":
    case "MessageReference": {
      const t = l(r.id);
      return e ? t : `$${t}`;
    }
    case "Variant": {
      const t = r.key.name ? r.key.name : r.key.value, n = l(r.value);
      return `${r.default ? "*" : " "}[${t}] ${n}`;
    }
    case "Placeable":
      return `{ ${l(r.expression)} }`.replace(/\n\s+}$/g, `
}`);
    default:
      throw new Error(`unknown item: ${JSON.stringify(r)}`);
  }
}, p = (r) => {
  var e;
  switch (r.type) {
    case "Comment":
    case "GroupComment":
    case "ResourceComment":
      return { key: "comment", value: r.content };
    case "Message":
      return {
        key: l(r.id),
        value: r.value ? l(r.value) : "",
        comment: r.comment && p(r.comment) || void 0,
        attributes: r.attributes.map(p)
      };
    case "Attribute":
      return {
        key: l(r.id),
        value: l(r.value)
      };
    case "Term":
      return {
        key: `-${l(r.id)}`,
        value: l(r.value),
        comment: r.comment ? p(r.comment) : void 0,
        attributes: r.attributes.map(p)
      };
    case "Junk": {
      const t = r.content.split("="), n = ((e = t.shift()) == null ? void 0 : e.trim()) || "", s = t.join("=").trim().replace(/\n {3}/g, `
 `).replace(/\n {2}}/g, `
}`);
      return { key: n, value: s };
    }
    default:
      throw new Error(`unknown item: ${JSON.stringify(r)}`);
  }
};
function L(r, e = { respectComments: !0 }) {
  if (typeof r != "string")
    throw new Error("The first parameter was not a string");
  return ee(r, { withSpans: !1 }).body.reduce((s, i) => {
    const a = p(i);
    if (!a)
      return s;
    if (a.attributes && a.attributes.length || a.comment && e.respectComments) {
      const c = { value: a.value };
      a.comment && (c[a.comment.key] = a.comment.value), a.attributes && a.attributes.length && a.attributes.forEach((f) => {
        c[f.key] = f.value;
      }), s[a.key] = c;
    } else
      s[a.key] = a.value;
    return s;
  }, {});
}
function te(r, e, t = { respectComments: !0 }) {
  try {
    e(null, L(r, t));
  } catch (n) {
    e(n, null);
  }
}
function ne(r, e, t = { respectComments: !0 }) {
  return e ? te(r, e, t) : L(r, t);
}
function y(r, e) {
  if (typeof r != "string" || typeof e != "string")
    throw new Error("called addValue with a non-string key or value");
  if (e && e.indexOf(`
`) > -1) {
    const t = `
  `, n = e.split(`
`).join(t);
    return `${r} =${t}${n}`;
  } else
    return `${r} = ${e}`;
}
function re(r) {
  if (typeof r != "string")
    throw new Error("called addComment with non-string value");
  return `# ${r.split(`
`).join(`
# `)}
`;
}
function se(r, e) {
  const t = Object.entries(r).map(([n, s]) => {
    const i = [];
    if (typeof s == "string")
      return `${y(n, s)}

`;
    if (s.comment && i.push(re(s.comment)), typeof s.value != "string")
      throw new Error(`Value ${n} with attributes had no value. Found: ${s.value}`);
    return i.push(y(n, s.value)), Object.entries(s).forEach(([a, c]) => {
      if (!(a === "comment" || a === "value")) {
        if (typeof c != "string")
          throw new Error(`Inner value ${a} with attributes had no value. Found: ${c}`);
        i.push(y(`
  .` + a, c));
      }
    }), i.push(`

`), i.join("");
  }).join("");
  return e && e(null, t), t;
}
const ie = { ftl2js: ne, js2ftl: se };
function ae(r) {
  return r.value !== void 0 && typeof r.value == "string" && (r.comment !== void 0 && typeof r.comment == "string" || !0);
}
function ce(r) {
  return r.value !== void 0 && typeof r.value == "string" && (r.comment !== void 0 && typeof r.comment == "string" || !0);
}
export {
  ie as default,
  ne as ftl2js,
  L as ftl2jsParse,
  ae as isFtlJsAttr,
  ce as isInnerFluentJs,
  se as js2ftl
};
//# sourceMappingURL=main.js.map
